import z from 'zod';

export const enable2FAflowSchema = z.object({
  target: z.string(),
});

export type Enable2FAFlowData = z.infer<typeof enable2FAflowSchema>;

export const authenticatorAppSchema = z.enum(['google', 'other']);

// ? SelectedApp is added client side on step 1 so the association step knows which flow to render
export const mfaSetupFlowSchema = z.object({
  Secret: z.string(),
  Uri: z.string(),
  SelectedApp: authenticatorAppSchema.optional(),
});

export const mfaRecoveryCodesFlowSchema = z.object({
  RecoveryCodes: z.array(z.string()),
});

export type AuthenticatorApp = z.infer<typeof authenticatorAppSchema>;
export type MfaSetupFlowData = z.infer<typeof mfaSetupFlowSchema>;
export type MfaRecoveryCodesFlowData = z.infer<typeof mfaRecoveryCodesFlowSchema>;
